module.exports = __webpack_public_path__ + "img/59e19eb.png";